window.CandidateEvents = {};

CandidateEvents.initNextPage = function () {
  let elem = document.getElementById('next-page-link')
  if (elem === null) { return }

  Waypoint.destroyAll()
  new Waypoint({
    element: elem,
    offset: 'bottom-in-view',
    handler: function (direction) {
      if (direction == 'down') {
        $('#next-page').html('<div class="loading"></div>')
        $.ajax({
          url: this.element.href,
          type: 'GET',
          dataType: 'script'
        })
      }
    }
  })
}

CandidateEvents.loadRecent = (url) => {
  $.ajax({
    url: url,
    type: 'GET',
    dataType: 'script'
  })
}
